class LoadMoreButton {
  constructor() {
    this.button = document.querySelector('.load-more-btn');
    this.productGrid = document.querySelector('#product-grid');
    this.loadMoreWrapper = document.querySelector('.load-more-wrapper');
    this.loadMoreInfo = document.querySelector('.load-more-info');
    
    if (this.button) {
      this.init();
    }
  }

  init() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMoreProducts();
    });
  }

  async loadMoreProducts() {
    const nextUrl = this.button.dataset.nextUrl;
    const currentPage = parseInt(this.button.dataset.currentPage);
    const totalPages = parseInt(this.button.dataset.totalPages);
    
    if (!nextUrl || currentPage >= totalPages) {
      return;
    }

    // Show loading state
    this.setLoadingState(true);

    try {
      // Fetch the next page
      const response = await fetch(nextUrl);
      const html = await response.text();
      
      // Create a temporary container to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Extract new products from the response
      const newProducts = tempDiv.querySelectorAll('#product-grid .grid__item');
      const newLoadMoreWrapper = tempDiv.querySelector('.load-more-wrapper');
      
      if (newProducts.length > 0) {
        // Add new products to the grid with animation
        newProducts.forEach((product, index) => {
          // Set initial state before adding to DOM
          product.style.opacity = '0';
          product.style.transform = 'translateY(20px)';
          product.classList.add('load-more-item');
          product.style.animationDelay = `${index * 0.1}s`;
          
          // Add to DOM
          this.productGrid.appendChild(product);
          
          // Trigger animation after a small delay
          setTimeout(() => {
            product.style.animation = 'fadeInUp 0.6s ease-out forwards';
          }, 10);
          
          // Remove animation class after animation completes
          setTimeout(() => {
            product.classList.remove('load-more-item');
            product.classList.add('animation-complete');
            product.style.animation = '';
            product.style.opacity = '';
            product.style.transform = '';
          }, 600 + (index * 100)); // 600ms animation + staggered delay
        });

        // Update the load more button with new data
        if (newLoadMoreWrapper) {
          const newButton = newLoadMoreWrapper.querySelector('.load-more-btn');
          const newInfo = newLoadMoreWrapper.querySelector('.load-more-info');
          
          if (newButton) {
            this.button.dataset.nextUrl = newButton.dataset.nextUrl;
            this.button.dataset.currentPage = newButton.dataset.currentPage;
            this.button.dataset.totalPages = newButton.dataset.totalPages;
          }
          
          if (newInfo) {
            this.loadMoreInfo.textContent = newInfo.textContent;
          }
        } else {
          // No more pages, hide the button
          this.loadMoreWrapper.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      // Show error state or fallback
    } finally {
      // Hide loading state
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.button.classList.add('loading');
      this.button.disabled = true;
    } else {
      this.button.classList.remove('loading');
      this.button.disabled = false;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LoadMoreButton();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoadMoreButton();
  });
} else {
  new LoadMoreButton();
}
